// Don't apply 'HeadingBuilder' for this component's 'Tippy contents' (table data)
import React, { useState, useContext } from 'react';
import { ShopperContext } from '../context/shopper';
import * as Constants from '../constants'
import { tax_multiplier, showRoundedAbsAmt, findAbsAmtAsPct,
            formatMoney,
            absAmtAsPctEvenIfWeighty } from '../utils';
import { usePricing, usePhrasing, useFormats } from "../hooks/useSkuUtils";
import { useStyles } from "../hooks/useStyles";
import { useOrderItemChangeHandlers } from "../hooks/useUtils";
import { InputDynamicText } from '../components/InputDynamicText';
import { OutlayAmt } from '../components/OutlayAmt';
import { OrderItemTable } from '../components/OrderItemTable';
import GetIcon from '../components/GetIcon';      
import { NumericFormat } from 'react-number-format';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { useTranslation } from "react-i18next";

import styled from 'styled-components';
import HeadingBuilder from './HeadingBuilder';
const Button = styled.button`
  /* Adapt the colors based on primary prop */
  background: ${props => props.primary ? Constants.O_BOX_GREEN : Constants.O_BOX_PINK};
  border: none;
  &.hover {
    background: #e7e7e7; color: black;
    transition: 0.3s;
  }
  /* color: ${props => props.primary ? "white" : "palevioletred"};

  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid palevioletred;
  border-radius: 3px; */
`;

const Order100Button = styled.button`
  background: lightblue;
  border: none;
`;
export const OrderItem = ({ order,
                            trip,
                            sku,
                            tsw,
                            inCartStatus,
                            actualWeight,
                            othData,
                            showOiTable,
                            handleOiClick,
                            if_shopper_is_circle_admin,
                            skuPrice,
                            headings,
                            showIdentifier,
                            showShortname,
                            showUnitCost,
                            skuAmtForShopper,
                            skuAmtForCircle
                          }) => {
  console.log("oi orig order", order);
  console.log("oi orig sku", sku);
  console.log("skuAmts for Shopper, Circle:", [skuAmtForShopper, skuAmtForCircle].join());
  const { shopper, prices, showOutlayWithTax, changeOrderItem,
          showSlimShopList,
          showOthersOrders,
        } = useContext(ShopperContext);
  console.log("pricesX", prices)
  console.log("showOutlayWithTaxX", showOutlayWithTax)
  const { t } = useTranslation();
  const { getPrice, getUnitCost, chopParenS,
          chooseDecimalScaleQty } = usePricing();
  
  const { editBoxStyle,
          textAlignRight,
            } = useStyles();
  const { noDotZero,
          getSingularString,
          orderItemNameLabelContent,
            } = usePhrasing();
  const { checkDecimalInput,
          spaceUnits,
        } = useFormats();
  const { handleMinMaxNoteClick } = useOrderItemChangeHandlers();

  const isMultipack = sku.type == "MultipackItem" ? true : false;
  const isSingular =  sku.type == "SingularItem" ? true : false;
  const isWeighty  =  sku.type == "WeightyItem" ? true : false;

  const [plusButtonIsGreen, setPlusButtonIsGreen] = useState(true);
  const [orderAmtButtonIsPink, setOrderAmtButtonIsPink] = useState(false);
  const [unitQty, setUnitQty] = useState( isSingular ? 0 : skuAmtForShopper );
  // Maybe this needs the original: Math.round(skuAmtForShopper * 100)/100
  
  // FIX ME: getting "NaN%" for Circle Amt for peanut butter: uq 1, uc 2
  const [absAmtAsPct, setAbsAmtAsPct] = useState(
    findAbsAmtAsPct({topNum: skuAmtForShopper, sku})
    // I expect it's best to leave this thing as a number, so no ".toString()"
  );
  console.log("oo_aqap", absAmtAsPct);
  console.log("osuc1", sku.unit_count);

  const sku_price    = getPrice({sku_id: sku.id, trip, prices});
  const currency_symbol = sku.circle.currency_symbol;
  const cstu = sku.circle.currency_subunit; // currency_subunit_to_unit, eg 100

  console.log("circamt", typeof skuAmtForCircle, skuAmtForCircle);
  const circleAmt    = skuAmtForCircle + skuAmtForShopper;
  const circleOutlayBeforeTax =
    findAbsAmtAsPct({topNum: circleAmt * sku_price, sku}) / 100;

  // Could anticipate/handle instances where the form field is "empty" via:
  //if (event.target.value == 0 || event.target.value == "" || event.target.value == "NaN")

  // Every orderItem reflects a record in the order_items table. What
  // matters here is that we capture changes in abs_amount of a sku,
  // PATCH them in.

return React.useMemo(() => {
  const circleOutlay = circleOutlayBeforeTax *
    (showOutlayWithTax
      ? tax_multiplier({
          tax_type: (sku.tax_type || 0),
          trip,
        })
      : 1
    );

  const singularStringGotten = getSingularString({sku});

  const handleClick100Button = (e) => {
    if (e.detail === 0) {
      // a return event occured
      // i.e. it's likely that shopper pressed the Enter key.
      // Intercept 'Enter' here. Otherwise, Enter acts as a click
      // and bumps the amt by another 100%.
      return;
    }

    // Shopper might clear out contents of unitQty/absAmtAsPct.
    // 'Click100' button should treat this empty input field as amt 0.
    if (isMultipack) {
      const currQtyFloat = parseFloat(unitQty) || 0;
      const qty100Amount = parseFloat(sku.unit_count);
      // TODO: I'm curious about why Multipack doesn't use 'String( )' here:
      e.target.value = currQtyFloat + qty100Amount;
      handleUnitQtyChange(e);
    }
    else if (isWeighty) {
      const currQtyFloat = parseFloat(unitQty) || 0;  // amt currently on order
      const qty100Amount = parseFloat(sku.typical_weight);  // 100 amt to add
      e.target.value = String(currQtyFloat + qty100Amount);

      handleUnitQtyChange(e);
    }
    else { // isSingular
      const currAmtFloat = parseFloat(absAmtAsPct) || 0;
      const qty100Amount = 100;
      e.target.value = String(currAmtFloat + qty100Amount);
      handleAbsAmtAsPctChange(e);
    }

    setOrderAmtButtonIsPink(true);
  }

  const handleClick = (e) => {
    setPlusButtonIsGreen(true);
    setOrderAmtButtonIsPink(false);
    console.log("spl hc sku1", order);
    console.log("spl hc sku1.5", order.id);
    console.log("spl hc sku2", e.target.value);
    const orderItem = {
      abs_amount: isSingular ?  parseFloat(absAmtAsPct) / 100  :  unitQty
    };
    changeOrderItem(orderItem, order.id);
  }

  const handleUnitQtyChange = (e) => {
    const newUnitQty = checkDecimalInput( {numInput: e.target.value} )

    setOrderAmtButtonIsPink(true);
    setPlusButtonIsGreen(false);
    console.log("huqc nuq", newUnitQty);
    setUnitQty(() => newUnitQty);
    if (isMultipack || isWeighty) {
        setAbsAmtAsPct( () => findAbsAmtAsPct({topNum: newUnitQty, sku}) )
    }
  }

  const handleAbsAmtAsPctChange = (e) => {
    // Remove any chars that are not digits.
    //const regex = /\D/g;
    // per https://bobbyhadz.com/blog/react-only-number-input
    // const newAbsAmtAsPct = e.target.value.replace(/\D/g, '');
    // FIXME: a user was triggering bad behavior by inserting '.' into value.
    // 33.3 was being treated as 333%, not 33.3%
    const newAbsAmtAsPct = checkDecimalInput( {numInput: e.target.value} )

    setOrderAmtButtonIsPink(true);
    setPlusButtonIsGreen(false);

    console.log("aqap1", absAmtAsPct);
    console.log("haqapc naqap", newAbsAmtAsPct);
    setAbsAmtAsPct( () => newAbsAmtAsPct )
    console.log("aqap2", absAmtAsPct);
  }

  // There was an error message about lists missing keys so I tried supplying
  // the list via this function. But then I tried putting the array there
  // again and it didn't complain. So, comment this out for now, keep watch.
  // const unitsForPrice = ({sku}) => {
  //   return [ <wbr/>, '/' , sku.units ]
  // }
  // <wbr/> (word break) allows "/lb" to appear below the price
  // (was for Price column)

  // We'll also normalize the "adjusted amount" values to show the percent
  // of 'unit_count' or 'actualWeight' that the order represents.
  // Thus the percentage we
  // show fits the "have we reached 100% of the order" expectation for that
  // value. Otherwise it shows scary percentages like 450% (for weighty) that
  // would represent purchasing 4.5 lbs (or whatever units) of the item.
  // If 'actualWeight' is 8, then we'll see values like 4.5 / 8 = 56%
  // The Rails model requires actualWeight values to be > 0.
  const adjustedCircleAmt =
    isMultipack
      ? circleAmt / sku.unit_count
      : (isWeighty && actualWeight)
        ? circleAmt / actualWeight
        : circleAmt;

  const adjustedAbsAmtAsPct =
                    absAmtAsPctEvenIfWeighty({absAmtAsPct, sku, actualWeight});
// How React onChange event handlers work - with code example
// https://sebhastian.com/react-onchange/

  // checkbox advice per https://www.robinwieruch.de/react-checkbox/
  // button advice per https://www.robinwieruch.de/react-button/
  // https://upmostly.com/tutorials/pass-a-parameter-through-onclick-in-react

  const orderData = {
    identifier:
  showIdentifier
    ?
      sku.identifier.length > Constants.MAX_SKU_IDENTIFIER_CHARS_BEFORE_TIPPY
        ? < HeadingBuilder
            containerType  = 'ellipsis'
            headingText    = {sku.identifier}
            tippyAlertText = {sku.identifier}
            tippyAlertIcon = {Constants.GET_ICON_ASTERISK}
            tippyText      = {sku.identifier}
          />
        : sku.identifier
        
    : < HeadingBuilder
        headingText    = {Constants.DOT}
        tippyAlertText = {sku.identifier}
        tippyAlertIcon = {Constants.GET_ICON_ASTERISK}
        tippyText      = {sku.identifier}
        forceShowAlertText = '1'
      />
    ,
    identifierV:
      sku.identifier
    ,
    brand:
      sku.brand
    ,
    label: orderItemNameLabelContent({
      sku, tsw, showSlimShopList,
    })
    ,
    storeLabel:
      sku.store_label
    ,
    shortname:
      shopper.shortname
    ,
    unitCount:
  <Tippy content= {t('orderItem.blue_unit_count.tippyContent', {
    character: Constants.O_COL_SYM
  })}>
{/* "Click the blue button to raise your order by one full sku.
     Then click the pink 'O' sign to add your order to your Circle's orders." */}
  {
    // "Unit Count" || Sku has this many units
    <Order100Button type="button" onClick={handleClick100Button}>
      {isMultipack
        ? noDotZero({num: sku.unit_count})
        : isWeighty
          ? sku.typical_weight
          : isSingular
            ? (singularStringGotten.length > 0  &&  singularStringGotten)
            : <span>--</span>
      }
    </Order100Button>
  }
  </Tippy>
    ,
    price:
  <>
    {
      formatMoney({
        currency_symbol,
        currency_subunit: cstu,
        amount: Math.trunc(sku_price * cstu) / cstu
      })
    }
    { isWeighty && [ <wbr key={'wbr' + order.id}/>, '/' , sku.units ] }
    {/* <wbr/> allows "/lb" to appear below the price */}
  </>
    ,
    unitQty:
  <>
  {   
  // "UnitQty" || Shopper wants this many units
    (isMultipack || isWeighty)
      ? <span><NumericFormat displayType="input"
          type="text"
          name="unitQty"
          onChange={e => handleUnitQtyChange(e)}
          onKeyUp={e => {
            if (e.key === 'Enter') {
              handleClick(e)
            }
          }}
          value={unitQty}
          decimalScale={ chooseDecimalScaleQty({sku}) }
          style={ editBoxStyle({ cellQty: unitQty,
            changeColorOfBox: orderAmtButtonIsPink,
            editBoxColor: Constants.O_BOX_PINK
          }) }
        /></span>

      : <span style={{ width: "70px" }} >--</span>
  }

  {/* For weighty items, helpful to show the unit of measure with the UnitQty.
  The value (e.g. "lb") shows below if the SWA window isn't wide enough.
  It shows beside (after) if the screen is wide enough. */}
  { isWeighty  &&  spaceUnits({units: sku.units }) }
  </>
    ,
    unitCost:
    (showUnitCost  ||  showSlimShopList  ||  showOiTable)
      ? <span>
          {/* TODO: Could change color and/or supply tooltip suggesting to use
          different units if getUnitCost value begins with '0.00' */}
          { getUnitCost({ currency_symbol, cstu, sku, sku_price}) }
            /{chopParenS(sku.units)}
            {/* This is unit cost, so we replace units like "battery(s)"
            with "battery" */}
        </span>
      : < HeadingBuilder
          headingText = {Constants.DOT}
        />
    ,
    wantd:
        // "%Wantd" ||
        (isMultipack || isWeighty || (showSlimShopList  &&  !showOiTable))
            ? <span style={{ width: "70px" }} >
                {showRoundedAbsAmt({ adjustedAbsAmtAsPct }) + "%"}
              </span>
            : <span><NumericFormat displayType="input"
                type="text"
                name="absAmtAsPct"
                onChange={e => handleAbsAmtAsPctChange(e)}
                onKeyUp={e => {
                  if (e.key === 'Enter') {
                    handleClick(e)
                  }
                }}
                value={absAmtAsPct}
                decimalScale={ chooseDecimalScaleQty({sku}) }
                style={ editBoxStyle({ cellQty: absAmtAsPct,
                  changeColorOfBox: orderAmtButtonIsPink,
                  editBoxColor: Constants.O_BOX_PINK
                }) }
              />%</span>
    ,
    rangeNote:
      <InputDynamicText
        initialText = {order.min_max_note || ''}
        handleTextClick = {handleMinMaxNoteClick(order.id)}
      />
    ,
    rangeNoteWide:
      <InputDynamicText
        initialText = {order.min_max_note || ''}
        handleTextClick = {handleMinMaxNoteClick(order.id)}
        rows = {5}
        cols = {26}
        checkboxPosition = "side"
      />
    ,
    outlay:
  <OutlayAmt
    trip        = {trip}
    sku         = {sku}
    sku_price   = {sku_price}
    order       = {order}
    decimal_amt = {
      findAbsAmtAsPct({
        topNum: isSingular ? parseFloat(absAmtAsPct)/100 : unitQty
        ,sku
      }) / 100
    }
    showOutlayWithTax = {showOutlayWithTax}
  />
    ,
    o:
    // "O" button:
  // Click the pink "O" sign to update the database with the amount you want
  // of the product.
    <Tippy content= {t('orderItem.o_col.tippyContent', {
      character: Constants.O_COL_SYM,
      whoWantsPhrase: t('orderItem.o_col.youWant')
    })} >
      <Button
        type    = "button"
        primary = {plusButtonIsGreen}
        value   = {order.id}
        onClick = {handleClick}
      >
        {Constants.O_COL_SYM}
      </Button>
    </Tippy>
    ,
    circleAmt:
    showRoundedAbsAmt({ adjustedAbsAmtAsPct: adjustedCircleAmt * 100 }) + "%"
    ,
    detailsLink:
      <GetIcon toGet={Constants.GET_ICON_DETAILS} />
    ,
    circleMoney:
      formatMoney({
        currency_symbol,
        amount: circleOutlay,
        currency_subunit: cstu
      })
    ,
    inCartStatus:
      inCartStatus
    ,
  }

  return (
showOiTable
  ? 
    <tr key={'oi' + order.id}>
      <td colSpan={Constants.VERTICAL_OI_COLUMNS} >
        <OrderItemTable
          handleClick = {handleOiClick}
          headings    = {headings}
          orderData   = {orderData}
          order       = {order}
          trip        = {trip}
          sku         = {sku}
          tsw         = {tsw}
          othData     = {othData}
          actualWeight= {actualWeight}
          skuPrice        = {skuPrice}
          inCartStatus    = {inCartStatus}
          if_shopper_is_circle_admin = {if_shopper_is_circle_admin}
        />
      </td>
    </tr>
  : <>
    <tr key={'oi' + order.id}>

{showSlimShopList
? null
: <>
<td className='fw-bold'>
  {orderData.identifier}
</td>

<td>{orderData.brand}</td>
</>
}
<td>
  {orderData.label}
</td>
{showSlimShopList
? null
:
<td>{orderData.storeLabel}</td>
}

{(showOthersOrders || showShortname)
?
<td className='fw-bold'>
  {orderData.shortname}
</td>
: null
}

{showSlimShopList
? null
:
<td className='fw-bold'>
  {orderData.unitCount}
</td>
}
<td style={textAlignRight}>
  {orderData.price}
</td>
{showSlimShopList
? null
: <>
<td>
  {orderData.unitQty}
</td>
<td>
  {orderData.unitCost}
</td>
</>
}
<td style={textAlignRight}>
  {orderData.wantd}
</td>
{showSlimShopList
? null
: <>
<td style={{ padding: '0 2px' }}>
  {orderData.rangeNote}
</td>
<td>
 <div className = "oneline-container-right">
  {orderData.outlay}
 </div>
</td>
<td>
  {orderData.o}
</td>
</>
}
<td style={textAlignRight}>
  {orderData.circleAmt}
</td>
{showSlimShopList
?
<td>
  <Order100Button type="button" onClick={handleOiClick}>
    {orderData.detailsLink}
  </Order100Button>
</td>
: <>
<td style={ textAlignRight }>
  {orderData.circleMoney}
</td>
<td>
  {/* React populates this cell with values when doing CSV download. */}
  {orderData.inCartStatus}
</td>
</>
}
    </tr>
  </>
  )
}, [
    showIdentifier,
    showShortname,
    showUnitCost,
    showSlimShopList,
    showOthersOrders,
    if_shopper_is_circle_admin,
    skuPrice,
    order,
    shopper,
    trip,
    sku,
    tsw,
    currency_symbol,
    cstu,
    inCartStatus,
    othData,
    headings,
    showOiTable,
    handleOiClick,
    orderItemNameLabelContent,
    plusButtonIsGreen,
    orderAmtButtonIsPink,
    t,
    showOutlayWithTax,
    editBoxStyle,
    textAlignRight,
    chopParenS,
    changeOrderItem,
    handleMinMaxNoteClick,
    actualWeight,
    absAmtAsPct,
    checkDecimalInput,
    chooseDecimalScaleQty,
    getUnitCost,
    spaceUnits,
    noDotZero,

    isMultipack,
    isSingular,
    isWeighty,
    getSingularString,
    circleOutlayBeforeTax,
    circleAmt,
    sku_price,
    unitQty
]);
}

export default OrderItem;
